import { render, staticRenderFns } from "./errorsorting.vue?vue&type=template&id=7b85a624&scoped=true&"
import script from "./errorsorting.vue?vue&type=script&lang=js&"
export * from "./errorsorting.vue?vue&type=script&lang=js&"
import style0 from "./errorsorting.vue?vue&type=style&index=0&id=7b85a624&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b85a624",
  null
  
)

export default component.exports